export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/wm-0fa5b96d18f9e74818f5acf3db92ebb5.png";